<template>
    <VJoySelect v-model="selectedCurrency" label="Currency" @update:model-value="handleCurrencyUpdate">
        <option v-for="currency in sortedCurrencies" :key="`currency--${currency.code}`" :value="currency.code">
            {{ currency.label }}
        </option>
    </VJoySelect>
</template>

<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {CurrencyCode} from '@navbar-unlogged-types/CurrencyCode';
    import {useTranslation} from '#imports';
    import {VJoySelect} from '@maltjoy/core-vue';

    interface Props {
        selectedCurrency: string;
    }

    type Currency = {
        code: CurrencyCode;
        label: string;
    };

    const {selectedCurrency: initialCurrency} = defineProps<Props>();

    const emit = defineEmits<{
        (e: 'update:currency', currencyCode: CurrencyCode): void;
    }>();

    const {t} = useTranslation();
    const selectedCurrency = ref(initialCurrency);

    const sortedCurrencies = computed(() =>
        Object.values(CurrencyCode)
            .map((code): Currency => ({
                code,
                label: t('general.currency.label', {currencyCode: code}),
            }))
            .sort((a, b) => a.label.localeCompare(b.label)),
    );

    function handleCurrencyUpdate(currencyCode: string) {
        emit('update:currency', currencyCode as CurrencyCode);
    }
</script>
